<template>
  <div>
    <v-dialog v-model="deleteDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="title">Delete</v-card-title>
        <v-card-text>Are you sure you want to Delete this {{ title }}{{ type==="multiple" ? "(s)" : "" }}?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-tooltip top>
            <v-btn slot="activator" flat @click="saveDeleteDialog">
              <v-icon color="green">check</v-icon>
            </v-btn>
            <span>Yes</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn slot="activator" flat @click="closeDeleteDialog">
              <v-icon color="pink">close</v-icon>
            </v-btn>
            <span>No</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    type: String,
    deleteDialog: Boolean
  },
  data() {
    return {};
  },
  methods: {
    saveDeleteDialog() {
      this.$emit("saveDeleteDialog");
    },
    closeDeleteDialog() {
      this.$emit("closeDeleteDialog");
    }
  }
};
</script>

<style>
</style>
